import aboutUsSlice from "./slices/aboutUsSlice";
import appointmentSlice from "./slices/appointmentSlice";
import loginSlice from "./slices/authSlice";
import branchesSlice from "./slices/branchesSlice";
import faqSlice from "./slices/faqSlice";
import gloablSlice from "./slices/globalSlice";
import hyperPaySlice from "./slices/hyperPaySlice";
import jobsSlice from "./slices/jobsSlice";
import loyaltyProgramDetailsSlice from "./slices/loyaltyProgramDetailsSlice";
import newsSlice from "./slices/newsSlice";
import offersSlice from "./slices/offersSlice";
import partnersSlice from "./slices/partnersSlice";
import serviceSlice from "./slices/servicesSlice";
import statisticsSlice from "./slices/statisticsSlice";
import testimoniesSlice from "./slices/testimoniesSlice";
import vehicleSlice from "./slices/vehicleSlice";
import warrantySlice from "./slices/warrantySlice";
import contactUsSlice from "./slices/contactUsSlice";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import privacySlice from "./slices/privacySlice";
import HeroSectionSlice from "./slices/HeroSectionSlice";
import termsSlice from "./slices/termsSlice";
import searchSlice from "./slices/search.slice";
import tabbySlice from "./slices/tabbySlice";
import  returnChangeSlice  from "./slices/returnSlice";
const persistConfig = {
  key: "root",
  storage,
  blacklist: ["cartReady", "cartLoading", "cartRequestId", "cartError"],
};

// Persisted reducer
const persistedReducer = persistReducer(persistConfig, gloablSlice);

const reducers = {
  login: loginSlice,
  vehicle: vehicleSlice,
  services: serviceSlice,
  appointmens: appointmentSlice,
  global: persistedReducer,
  partners: partnersSlice,
  program: loyaltyProgramDetailsSlice,
  testimonies: testimoniesSlice,
  statistics: statisticsSlice,
  news: newsSlice,
  about: aboutUsSlice,
  faq: faqSlice,
  offers: offersSlice,
  branches: branchesSlice,
  warranty: warrantySlice,
  contactUs: contactUsSlice,
  hyperPay: hyperPaySlice,
  jobs: jobsSlice,
  privacy: privacySlice,
  heroSection: HeroSectionSlice,
  terms: termsSlice,
  search: searchSlice,
  tabby: tabbySlice,
  returnChange : returnChangeSlice
};

export default reducers;
